import { render, staticRenderFns } from "./UserMyOrgs.vue?vue&type=template&id=3ede4f9e"
import script from "./UserMyOrgs.vue?vue&type=script&lang=js"
export * from "./UserMyOrgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports